import React from 'react';
import Lottie from 'react-lottie';
import './Gpay_lottie.css';
import * as animationData from './Gpay_lottie.json';
import { Link } from 'react-router-dom';

const Gpay_lottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            <Link to={"https://play.google.com/"} target='_blank'>
                <section className='main'>
                    <div className='Location_lottie_icon'>
                        <Lottie className="me-auto"
                            options={defaultOptions}
                        />
                    </div>
                </section>
            </Link>
        </>
    )
}

export default Gpay_lottie
